import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const TopContentService = ({ service }) => {
  const desc0 = service.description?.[0];
  const banner_images = service.images?.slice(0, 6);
  const hasMultiple = banner_images?.length > 1;
  return (
    <div>
      <div className="max-h-screen lg:max-h-[80vh] overflow-hidden rounded-md">
        {/* {service.images?.[0] ? (
          <img
            src={service.images[0]}
            alt=""
            className="w-full h-auto sm:max-h-[70vh] object-cover lg:object-cover"
          />
        ) : (
          <div className="w-full h-60 bg-gray-200 flex items-center justify-center">
            No Image available
          </div>
        )} */}
        <div
          className="w-full rounded-lg overflow-hidden"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          {hasMultiple ? (
            <Swiper
              className="rounded-lg w-full h-64 sm:h-80 md:h-96 lg:h-[32rem] overflow-hidden shadow-lg campaign-swiper"
              modules={[Navigation, Pagination, Autoplay]}
              navigation={{
                enabled: window.innerWidth >= 768, // Enable navigation only on desktop
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop
              speed={800}
              breakpoints={{
                320: {
                  navigation: {
                    enabled: false,
                  },
                },
                768: {
                  navigation: {
                    enabled: true,
                  },
                },
              }}
            >
              {banner_images?.map((img, index) => (
                <SwiperSlide key={index} className="h-full w-full">
                  <img
                    src={img}
                    alt=""
                    className="w-full h-full object-cover object-center transition-transform duration-300 hover:scale-105"
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            banner_images?.[0] && (
              <div className="relative overflow-hidden rounded-lg shadow-lg">
                <img
                  src={banner_images[0]}
                  alt="Campaign banner"
                  className="w-full h-64 sm:h-80 md:h-96 lg:h-[32rem] object-cover object-center rounded-lg transition-transform duration-300 hover:scale-105"
                  loading="eager"
                />
              </div>
            )
          )}
        </div>
      </div>

      <div className="my-3">
        <h2 className="text-2xl md:text-3xl font-bold tracking-wide font-onest">
          {service.serviceName}
        </h2>
      </div>
      {/* <p className=" md:text-xl py-4 text-donationtext text-justify ">
        <span className="block font-semibold text-2xl mb-4 text-justify font-onest">
          {desc0?.heading}
        </span>
        <span className="text-lg">{desc0?.content}</span>
      </p> */}
    </div>
  );
};

export default TopContentService;
